import { Link, useNavigate } from 'react-router-dom';

import cloudPartitioner from '../assets/images/aws_cloud_practitioner.png';

const AwsCloudPartitionerPage = () => {
  const navigate = useNavigate();
  return (
    <div className='rounded-b-2xl rounded-tl-2xl rounded-tr-xl bg-gradient-to-b from-indigo-100 to-white px-6 py-10'>
      {/* Breadcrumb */}
      <div className='mb-4 text-sm text-gray-500'>
        <button onClick={() => navigate('/cloud-prep')}>Home</button> &gt;{' '}
        <span className='text-indigo-600'>
          AWS Certified Cloud Practitioner
        </span>
      </div>

      {/* Header Section */}
      <div className='mb-10 mt-10 text-left'>
        <h1 className='mb-2 text-3xl font-bold text-gray-900'>
          AWS Certified Cloud Practitioner
        </h1>
        <p className='text-lg text-gray-600'>
          Showcase foundational knowledge of AWS cloud services and cloud
          computing.
        </p>

        <button className='mt-6 rounded-full bg-gray-900 px-6 py-2 text-white transition hover:bg-gray-800'>
          Schedule an exam
        </button>
      </div>

      {/* Badge and Description Section */}
      <div className='mb-16 flex flex-col items-center justify-center gap-10 bg-[#F3F3F7] md:flex-row'>
        <img
          src={cloudPartitioner}
          alt='AWS Certified Cloud Practitioner Badge'
          width={400}
          height={400}
          className='rounded-lg'
        />
        <div className='mt-3 max-w-md pr-6'>
          <h2 className='mb-2 text-xl font-semibold text-gray-800'>
            AWS Certified Cloud Practitioner
          </h2>
          <p className='mb-3 leading-relaxed text-gray-600'>
            The AWS Certified Cloud Practitioner validates foundational,
            high-level understanding of AWS Cloud, services, and terminology.
            This is a good starting point for individuals with no prior IT or
            cloud experience switching to a cloud career or for line-of-business
            employees looking for foundational cloud literacy.
          </p>
          <a
            href='#'
            className='text-sm font-medium text-indigo-600 hover:underline'
          >
            Schedule your exam
          </a>
        </div>
      </div>

      {/* Exam Overview Section */}
      <div className='mx-auto mt-8 max-w-5xl'>
        <h3 className='mb-6 text-2xl font-bold text-gray-900'>Exam overview</h3>
        <div className='grid grid-cols-1 gap-8 text-gray-700 md:grid-cols-2'>
          <div>
            <p className='text-sm text-gray-600'>
              AWS Certified Cloud Practitioner
            </p>
          </div>
          <div className='space-y-3'>
            <div>
              <p className='font-semibold'>Category</p>
              <p>Foundational</p>
            </div>
            <div>
              <p className='font-semibold'>Exam duration</p>
              <p>90 minutes</p>
            </div>
            <div>
              <p className='font-semibold'>Exam format</p>
              <p>65 questions; either multiple choice or multiple response</p>
            </div>
            <div>
              <p className='font-semibold'>Cost</p>
              <p>
                100 USD. Visit{' '}
                <a href='#' className='text-indigo-600 hover:underline'>
                  Exam pricing
                </a>{' '}
                for details.
              </p>
            </div>
            <div>
              <p className='font-semibold'>Test in-person or online</p>
              <p>Pearson VUE testing center or online proctored exam</p>
            </div>
            <div>
              <p className='font-semibold'>Languages offered</p>
              <p className='text-sm'>
                Arabic, English, Bahasa (Indonesian), French (France), German,
                Italian, Japanese, Korean, Portuguese (Brazil), Spanish (Latin
                America), Spanish (Spain), Simplified Chinese, and Traditional
                Chinese
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='mb-10 mt-8'>
        <Link
          target='_blank'
          rel='noopener noreferrer'
          to='https://aws.amazon.com/certification/certified-cloud-practitioner/'
          className='underline'
        >
          Learn More
        </Link>
      </div>
    </div>
  );
};

export default AwsCloudPartitionerPage;
